import React from 'react';
import PageContainer from '../PageContainer';
import './identity.scss';
import ibrahim from './ibrahim.jpg';
import inam from './inam.jpg';
import sevan from './sewan.jpg';
import { ReactComponent as Play } from './play-circle.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faMap, faQuestion, faUser } from '@fortawesome/free-solid-svg-icons';
import PageTitle from '../PageTitle';
import ibrahimVideo from '../videos/Portrettfilm/Portrett-Ibrahim-tekstet-151220.mp4'
import inamVideo from '../videos/Portrettfilm/Portrett-Inam-tekstet-151220.mp4'
import sevanVideo from '../videos/Portrettfilm/Portrett-Sevan-tekstet-151220.mp4'
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { videos } from './videos';
import { greyText } from '../styles';
import { MediaQueryContext } from '../MediaQueryContext';

export const people = [
  {
    name: 'Ibrahim',
    location: 'Iraq',
    image: ibrahim,
    key: "ib-v",
    video: ibrahimVideo,

  },
  {
    name: 'Inam',
    location: 'Syria',
    image: inam,
    key: "in-v",
    video: inamVideo,


  },
  {
    name: 'Sevan',
    location: 'Syria',
    image: sevan,
    key: "se-v",
    video: sevanVideo,

  }];

export const questions = [
  { no: "Hvordan definerer du din identitet?", en: "How do you define your identity?", key: "qu1" },
  { no: "Hvilken betydning hadde din identiteten før flukten og var det grunnen for flukten?", en: "In what way was your identity significant before you had to flee and was that the reason for flight?", key: "qu2" },
  { no: "Har identiteten din endret seg etter at du kom til Norge?", en: "Has your identity changed after you came to Norway?", key: "qu3" },
  { no: "Hvor føler du deg mest hjemme?", en: "Where do you feel most at home?", key: "qu4" },
  { no: "Hvor og når føler du deg mest fremmed?", en: "Where do you feel most like a stranger?", key: "qu5" },
  { no: "Kan du uttrykke alle sider ved din identitet i Norge?", en: "Are you able to express all sides of your identity in Norway?", key: "qu6" },
  { no: "Kan du uttrykke alle sider ved din identitet om du reiser tilbake til ditt opprinnelsesland?", en: "Are you able to express all sides of your identiy if you go back to your country of origion?", key: "qu7" },
  { no: "Hvorfor tror du noen minoriteter blir undertrykt?", en: "Why do you think some minorities are oppressed?", key: "qu8" },
  { no: "Are you comfortable in your own skin?", en: "Are you comfortable in your own skin?", key: "qu9" },
]


class Identity extends React.Component {
  static contextType = MediaQueryContext;

  constructor() {
    super();
    this.state = { currentQuestion: 0, playingVideo: null, showVideo: false, mode: 'questions' };
    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
    this.playVideo = this.playVideo.bind(this);
    this.start = this.start.bind(this);
    this.clearVideo = this.clearVideo.bind(this);
    this.currentVideo = React.createRef();
  }

  next() {
    let currentQuestion = this.state.currentQuestion + 1;
    if (currentQuestion > questions.length - 1) {
      currentQuestion = 0;
    }
    this.setState({ currentQuestion });
  }

  prev() {
    let currentQuestion = this.state.currentQuestion - 1;
    if (currentQuestion < 0) {
      currentQuestion = questions.length - 1;
    }
    this.setState({ currentQuestion });
  }

  playVideo(e, video) {
    e.stopPropagation();
    console.log(video)
    this.setState({ playingVideo: video, showVideo: true });

    setTimeout(() => { this.currentVideo.current?.play() }, 600)
  }

  start() {
    this.currentVideo.current.play();
  }

  clearVideo() {
    this.setState({ showVideo: false });
    setTimeout(() => { this.setState({ playingVideo: null }); }, 600)


  }

  toggle(e) {
    e.stopPropagation();
    this.setState((state) => ({ showVideo: !state.showVideo }));

  }
  render() {
    let currentVideos = videos.filter(vid => vid.question === this.state.currentQuestion);
    return (
      <PageContainer {...this.props} className="identity">
        <div className="identity-container" key="id-cont" onClick={this.clearVideo}>
          <PageTitle key="pt">WHAT ABOUT IDENTITY?</PageTitle>

          <div className="page-subtitle">
            <i>Portrait interviews of three people with a minority and refugee background</i>
            <br />
            <i style={{ color: greyText, marginBottom: '5rem' }}>Portrett intervjuer av tre mennesker med flyktning- og minoritetsbakgrunn</i>
          </div>

          <div className="heading">
            <button className={this.state.mode === 'questions' ? 'button primary' : 'button secondary'} onClick={() => this.setState({ mode: 'questions' })}>Individual questions</button>
            <button className={this.state.mode === 'full' ? 'button primary' : 'button secondary'} onClick={() => this.setState({ mode: 'full' })}>Full interviews</button>

          </div>

          <>



            {this.state.mode === 'full' && <div className="full-videos" key="fv">
              {people.map(interview => (
                <div className="identity-person" key={interview.key} onClick={(e) => this.playVideo(e, interview)}>
                  <div className="image-container">
                    <div className="image" style={{ backgroundImage: `url(${interview.image})` }} />
                    <Play />
                  </div>
                  <ul>
                    <li><FontAwesomeIcon icon={faUser} /><span>{interview.name}</span></li>
                    <li><FontAwesomeIcon icon={faMap} /><span>{interview.location}</span></li>
                  </ul>
                </div>)
              )}
            </div>}

            {this.state.mode === 'questions' && <div className="questions" key="qu">

              <SwitchTransition >
                <CSSTransition timeout={300} key={questions[this.state.currentQuestion].key} appear classNames="question-transition" >
                  <div className="current-question">
                    <p>{questions[this.state.currentQuestion]?.en}</p>
                    <p style={{ color: greyText }}>{questions[this.state.currentQuestion]?.no}</p>
                  </div>

                </CSSTransition>
              </SwitchTransition>

              <SwitchTransition >
                <CSSTransition timeout={600} key={questions[this.state.currentQuestion].key} appear classNames="videos-transition" >
                  <div className="question-videos">
                    {currentVideos.map(video => {
                      let person = people.find(person => person.name === video.person);
                      return (<div key={video.key} className="identity-video">

                        <div className="image-container" onClick={(e) => this.playVideo(e, video)}>
                          <div className="image" style={{ backgroundImage: `url(${person.image})` }} />
                          <Play />
                        </div>

                      </div>)
                    })
                    }
                  </div>
                </CSSTransition>
              </SwitchTransition>

              <div className="question-buttons center column">

                <button className="button secondary next-question" onClick={this.prev}>
                  <FontAwesomeIcon icon={faChevronLeft} />
                  <span>PREVIOUS QUESTION</span>
                </button>

                <button className="button secondary next-question" onClick={this.next}>
                  <span>NEXT QUESTION</span>
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>

              </div>

              <div className="counter center">
                <SwitchTransition>

                  <CSSTransition classNames='fade'
                    timeout={500} key={'q-' + this.state.currentQuestion} in={this.state.currentQuestion !== ""} >
                    <span> {this.state.currentQuestion + 1}</span>
                  </CSSTransition>
                </SwitchTransition>
                <span>/</span>
                <span> {questions.length}</span>
              </div>

            </div>}


            <CSSTransition timeout={600} classNames="video-animation" appear in={this.state.showVideo}
              mountOnEnter unmountOnExit
              onEnter={node => node.offsetHeight}
              onExit={node => node.offsetHeight}>
              <div key={this.state.playingVideo?.key + '-pl'} className="active-video" >
                <video ref={this.currentVideo} width="640" height="auto" onClick={(e) => this.toggle(e)} controls onPause={(e) => this.toggle(e)}>
                  <source src={this.state.playingVideo?.video + "#t=0.1"} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
              </div>

            </CSSTransition>

          </>
        </div>
      </PageContainer>
    );
  }
}

export default Identity;
